import { ApiError } from '@/api/Error';

export const extractErrorMessage = (error: unknown): string => {
  if (error instanceof ApiError) {
    return error.code ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'An unexpected error occurred. Please try again.';
};
